//
import { ModuleLayout } from '@/components/reusable_components/next'

//
import KardexListView from '@/views/Warehouse/WhKardex/list'

//
export default {
    path: 'kardex',
    component: ModuleLayout,
    children: [
        {
            path: '',
            name: 'kardex-list',
            component: KardexListView,
        },
    ],
    meta: {
        title: 'Tarjetas de existencia',
    },
}
